import { Component } from '@angular/core';

@Component({
    selector: 'fcp-error',
    templateUrl: './fcp-error.component.html',
    styleUrls: ['./fcp-error.component.less'],
    standalone: false
})
export class FcpErrorComponent {
    iconName = 'circle-exclamation';
}
